import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import {URLS} from '../constants/appConstants';
import {faker} from '@faker-js/faker';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import * as React from 'react';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import FollowersDialog from './QuesAndAns/FollowersDialog'
import PointsDetailDialog from '../components/dialogs/PointsDetailDialog'
import CoinsDetailDialog from './dialogs/CoinsDetailDialog';
import FollowButton from './FollowButton';
import RatingChip from './common/RatingChip';
import {getNumberOfRating} from '../utils/helper';

export default function ProfileOverview({isCurrentUser}) {
  const navigate = useNavigate();
  const [isFollowing, setIsFollwing] = useState(false);
  return <>
    <Card sx={{mb: 2}}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Stack spacing={0}>
              <Avatar
                onClick={() => {
                  navigate(URLS.IMAGE_FULL_SCREEN)
                }}
                alt={faker.person.firstName()}
                sx={{width: 80, height: 80}}
              />
              {<RatingChip/>}
              {getNumberOfRating()} Ratings

            </Stack>
          </Grid>
          <Grid item xs={8}>
            <Stack spacing={1}>
              <p>{faker.person.fullName()}</p>
              <p><b>@{faker.person.firstName()}</b></p>
              <PointsDetailDialog/>
              <Stack spacing={1} direction={'column'}>
                <FollowButton/>
                <Stack spacing={1} direction={'row'}>
                  {isCurrentUser &&
                    <Button size="small" fullWidth={true} variant="outlined" onClick={() => {
                      navigate(URLS.PROFILE_EDIT)
                    }}>
                      Edit
                    </Button>}
                  <Button size="small" variant="outlined" fullWidth={true}>Share</Button>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{textAlign: 'center', mt: 1}}>
          {isCurrentUser &&
            <Grid item xs={3}>
              <CoinsDetailDialog/>
            </Grid>
          }
          <Grid item xs={4}>
            <FollowersDialog followString='Followers'/>
          </Grid>
          <Grid item xs={4}>
            <FollowersDialog followString='Following'/>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </>
}
